@let selectedbuttonIdValue$ = selectedbuttonId$();
@let iconPropertiesValue = iconProperties();
@if (selectedbuttonIdValue$) {
  @if ((selectedbuttonIdValue$ | async) === iconPropertiesValue.icons[1].id) {
    <button
      class="mapboxgl-ctrl-button-1"
      aria-label="Button 1"
      aria-disabled="false"
      type="button"
      (click)="onClickBinaryButton(iconPropertiesValue.icons[0].id)">
      <ng-container
        appIcon
        [iconName]="iconPropertiesValue.icons[0].iconName"
        [iconMappings]="iconPropertiesValue.iconMappings"></ng-container>
    </button>
  } @else if (
    (selectedbuttonIdValue$ | async) === iconPropertiesValue.icons[0].id
  ) {
    <button
      class="mapboxgl-ctrl-button-2"
      aria-label="Button 2"
      aria-disabled="false"
      type="button"
      (click)="onClickBinaryButton(iconPropertiesValue.icons[1].id)">
      <ng-container
        appIcon
        [iconName]="iconPropertiesValue.icons[1].iconName"
        [iconMappings]="iconPropertiesValue.iconMappings"></ng-container>
    </button>
  }
}
